export const couponRoutes = {
	coupons: (query?: string) => `/coupons/${query ? `?${query}` : ''}`,
	coupon: (id: string) => `/coupons/${id}/`,
	couponHistory: (id: string) => `/coupons/${id}/history/`,
	couponsExport: (query?: string) => `/coupons/export/${query ? `?${query}` : ''}`
} as const
